import { render, staticRenderFns } from "./ContentBlocks.vue?vue&type=template&id=4e6babd9&scoped=true"
import script from "./ContentBlocks.vue?vue&type=script&lang=js"
export * from "./ContentBlocks.vue?vue&type=script&lang=js"
import style0 from "./ContentBlocks.vue?vue&type=style&index=0&id=4e6babd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6babd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
